import {useClinicianStyles} from './useClinicianStyles';
import {useTranslation} from 'react-i18next';
import useOpenState from '../../../hooks/useOpenState';
import React, {useRef} from 'react';
import _ from 'lodash';
import moment from 'moment/moment';
import Grid from '@mui/material/Grid';
import AgyleTextField from '../../../components/ui/fields/agyleTextField';
import AgyleButton from '../../../components/ui/buttons/agyleButton';
import MessageBox from '../../../util/messageBox';
import MedicalNurseNotes from './medicalNurseNotes';

export function MedicalNursePlanInput(props) {
    const classes = useClinicianStyles();
    const {t, i18n} = useTranslation();
    const {
        setFormIsModified,
        medicalNursingNotes,
        setMedicalNursingNotes,
        setAddBtnSeen,
        initialNote,
        setInitialNote,
        initNote,
        user,
        seen,
        fromTimestamp,
    } = props;

    // Uncheck note
    const [isConfirmOpen, openConfirm, closeConfirm] = useOpenState(false, true);
    const tempNoteObj = useRef(null);

    const handleConfirm = (note) => {
        tempNoteObj.current = note;
        openConfirm();
    };

    const handleClearStatus = () => {
        if (tempNoteObj.current) {
            let notes = medicalNursingNotes.map(n => n.id === tempNoteObj.current?.id ? tempNoteObj.current : n);

            notes = _.sortBy(notes, ['checked']);
            setMedicalNursingNotes(notes);
            tempNoteObj.current = null;
            closeConfirm();
            setFormIsModified(true);
        }
    };

    const handleAddNote = () => {
        if (initialNote.text) {
            let cloneNotes = medicalNursingNotes ? _.cloneDeep(medicalNursingNotes) : [];
            cloneNotes.push({
                ...initialNote,
                timestamp: moment().toISOString(),
                createdBy: seen?.who,
            });

            cloneNotes = _.sortBy(cloneNotes, ['checked']);

            setMedicalNursingNotes(cloneNotes);
            setInitialNote(initNote);
            setFormIsModified(true);
            setAddBtnSeen(false);
        }
    };

    return (
        <>
            {medicalNursingNotes.length > 0 &&
                <MedicalNurseNotes
                    notes={medicalNursingNotes}
                    setNotes={setMedicalNursingNotes}
                    setFormIsModified={setFormIsModified}
                    user={user}
                    setAddBtnSeen={setAddBtnSeen}
                    setInitialNote={setInitialNote}
                    handleConfirm={handleConfirm}
                />
            }

            <Grid
                container
                className={classes.noteField}
                flexDirection="row"
                justifyContent="space-between"
                style={{marginBottom: 15}}
            >
                <AgyleTextField
                    size={props.refresh ? 'large' : 'small'}
                    variant="outlined"
                    className={'custom-dt'}
                    placeholder={t('Enter note (max. 50 characters)')}
                    style={{width: '78%'}}
                    label={t('Note')}
                    onChange={(e) => {
                        setInitialNote((prevValue) => ({
                            ...prevValue, text: e.target.value,
                        }));
                        setFormIsModified(true);
                    }}
                    value={initialNote.text}
                    maxLength={50}
                    noBorder={false}
                    withNewBackground
                />

                <AgyleButton
                    style={{marginTop: 2}}
                    variant="contained"
                    color="primary"
                    onClick={handleAddNote}
                    disabled={fromTimestamp ? false : !seen?.who}
                >
                    Add Note
                </AgyleButton>
            </Grid>

            <MessageBox
                title={t('Confirmation')}
                haveAccept={{yes: t('Yes'), no: t('No')}}
                onAccept={handleClearStatus}
                onClose={() => {
                    tempNoteObj.current = null;
                    closeConfirm();
                }}
                message={t('Are you sure you want to uncheck status complete?')}
                open={isConfirmOpen}
            />
        </>
    );
}